import { Injectable, OnDestroy } from '@angular/core';
import { Subject, BehaviorSubject, fromEvent } from 'rxjs';
import { takeUntil, debounceTime } from 'rxjs/operators';
import { Router } from '@angular/router';
import { SharedHttpService } from './shared-http.service';

// Menu
export interface Menu {
    headTitle1?: string,
    headTitle2?: string,
    path?: string;
    title?: string;
    icon?: string;
    type?: string;
    badgeType?: string;
    badgeValue?: string;
    active?: boolean;
    bookmark?: boolean;
    children?: Menu[];
}

@Injectable({
    providedIn: 'root'
})

export class NavService implements OnDestroy {

    private unsubscriber: Subject<any> = new Subject();
    public screenWidth: BehaviorSubject<number> = new BehaviorSubject(window.innerWidth);

    // Search Box
    public search: boolean = false;

    // Language
    public language: boolean = false;

    // Mega Menu
    public megaMenu: boolean = false;
    public levelMenu: boolean = false;
    public megaMenuColapse: boolean = window.innerWidth < 1199 ? true : false;

    // For Horizontal Layout Mobile
    public horizontal: boolean = window.innerWidth < 991 ? false : true;

    // Collapse Sidebar
    public collapseSidebar: boolean = window.innerWidth < 991 ? true : false;

    // Full screen
    public fullScreen: boolean = false;

    constructor(private router: Router, shared: SharedHttpService) {
        let user = JSON.parse(localStorage.getItem("user"));
        this.setScreenWidth(window.innerWidth);
        fromEvent(window, 'resize').pipe(
            debounceTime(1000),
            takeUntil(this.unsubscriber)
        ).subscribe((evt: any) => {
            this.setScreenWidth(evt.target.innerWidth);
            if (evt.target.innerWidth < 991) {
                this.collapseSidebar = true;
                this.megaMenu = false;
                this.levelMenu = false;
            }
            if (evt.target.innerWidth < 1199) {
                this.megaMenuColapse = true;
            }
        });
        if (window.innerWidth < 991) { // Detect Route change sidebar close
            this.router.events.subscribe(event => {
                this.collapseSidebar = true;
                this.megaMenu = false;
                this.levelMenu = false;
            });
        }

        /*this.MENUITEMS.push({ title: 'Home', icon: 'home', path: '/CasesList', type: 'link' });*/


      
        this.MENUITEMS.push({ title: 'Home', icon: 'home', path: '/', type: 'link' });

        this.MENUITEMS.push({
            title: 'violations', icon: 'file', path: '/violations/list', type: 'link', badgeType: 'success', active: true
        });

        this.MENUITEMS.push({
            title: 'Objections', icon: 'database', type: 'sub'  ,badgeType: 'success', active: true
            , children: [
                { path: '/objections/inbox', title: 'Inbox', type: 'link' },
                { path: '/objections/outbox', title: 'Sent', type: 'link' },
                { path: '/objections/finished', title: 'Finished', type: 'link' },
                { path: '/objections', title: 'AllObjections', type: 'link' },

            ]
        });

      

        this.MENUITEMS.push({
            title: 'Companies', icon: 'file-text', path: '/company/getCompanyByCR', type: 'link', badgeType: 'success', active: true
        });

        this.MENUITEMS.push({
            title: 'Persons', icon: 'file-text', path: '/member/memberInfo', type: 'link', badgeType: 'success', active: true
        });

        if (user.userRoleId == 1) {

        this.MENUITEMS.push({
            title: 'Settings', icon: 'settings', path: '/settings', type: 'sub', badgeType: 'success', active: true, children: [
                { path: '/settings/users', title: 'Users', type: 'link' },
                { path: '/settings/applications', title: 'Applications', type: 'link' },
            ]
        });
    }





    }

    ngOnDestroy() {
        // this.unsubscriber.next();
        this.unsubscriber.complete();
    }


    private setScreenWidth(width: number): void {
        this.screenWidth.next(width);
    }



    //let settings=


    MENUITEMS: Menu[] = [



    ];

    MEGAMENUITEMS: Menu[] = [

    ];

    LEVELMENUITEMS: Menu[] = [

    ];

    // Array
    items = new BehaviorSubject<Menu[]>(this.MENUITEMS);
    megaItems = new BehaviorSubject<Menu[]>(this.MEGAMENUITEMS);
    levelmenuitems = new BehaviorSubject<Menu[]>(this.LEVELMENUITEMS);

}
